import { render, staticRenderFns } from "./MlbNews.vue?vue&type=template&id=1298d712&scoped=true"
import script from "./MlbNews.vue?vue&type=script&lang=js"
export * from "./MlbNews.vue?vue&type=script&lang=js"
import style0 from "./MlbNews.vue?vue&type=style&index=0&id=1298d712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1298d712",
  null
  
)

export default component.exports